
import { Component, Vue } from 'vue-property-decorator'
import RacingResultService from '@/biz/service/Racing/RacingResultService'
import RacingGroupService from '@/biz/service/Racing/RacingGroupService'
import RacingService from '@/biz/service/Racing/RacingService'
import { arrayChunk } from '@/service/ToolsService'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import print from 'vue-print-nb'

@Component({
  directives: {
    print
  }
})
export default class ViewRacingPrintRallyStart extends Vue {
  private RacingGroupService = RacingGroupService
  private RacingService = RacingService
  private list = [] as any[][]

  private handleLoad () {
    return RacingResultService.printTotalResultTable({ isPrize: 1 })
      .then((res) => {
        this.list = arrayChunk(res.data, 5)
      })
  }
}
